import { getDashboardPlatformsControllerListQueryKey } from "@/api/__generated__/dashboard-platforms/dashboard-platforms";
import { MessageKey } from "@/i18n";
import {
  DateFormatPreference,
  PlatformExportColumn,
  PlatformExportColumnValues,
  PlatformStatus,
  PlatformType,
  TimeFormatPreference,
} from "@/types";

export const PLATFORM_IDS = {
  LRF: "46",
  USPA: "56",
};

export const PLATFORM_STATUS_LABELS: { [key in PlatformStatus]: MessageKey } = {
  active: "platform.enums.status.active",
  inactive: "platform.enums.status.inactive",
};

export const PLATFORM_TYPE_LABELS: { [key in PlatformType]: MessageKey } = {
  governingBody: "platform.enums.type.governingBody",
  marketplace: "platform.enums.type.marketplace",
  tourOperator: "platform.enums.type.tourOperator",
  clubChain: "platform.enums.type.clubChain",
  club: "platform.enums.type.club",
  event: "platform.enums.type.event",
  other: "platform.enums.type.other",
};

export const DATE_FORMAT_PREFERENCE_LABELS: { [key in DateFormatPreference]: MessageKey } = {
  "dd/mm/yyyy": "platform.enums.dateFormat.ddMmYyyy",
  "mm/dd/yyyy": "platform.enums.dateFormat.mmDdYyyy",
  "yyyy/mm/dd": "platform.enums.dateFormat.yyyyMmDd",
};

export const TIME_FORMAT_PREFERENCE_LABELS: { [key in TimeFormatPreference]: MessageKey } = {
  "12H": "platform.enums.timeFormat.twelveHour",
  "24H": "platform.enums.timeFormat.twentyFourHour",
};

export const PLATFORMS_INVALIDATE_KEYS = [getDashboardPlatformsControllerListQueryKey()];

export const PLATFORM_EXPORT_COLUMNS: readonly PlatformExportColumn[] = PlatformExportColumnValues;

export const PLATFORM_EXPORT_COLUMN_LABELS: { [key in PlatformExportColumn]: MessageKey } = {
  title: "general.columns.title",
  abbreviation: "platform.export.columns.abbreviation",
  status: "general.columns.status",
  owner: "general.columns.owner",
  sports: "platform.columns.sports",
  usersCount: "platform.export.columns.usersCount",
  leaguesCount: "platform.columns.leagues",
  tournamentsCount: "platform.columns.tournaments",
  issuedLicensesCount: "platform.columns.issuedLicenses",
  issuedCertificatesCount: "platform.columns.issuedCertificates",
  issuedApplicationFormsCount: "platform.columns.issuedApplicationForms",
  entriesCount: "platform.export.columns.entriesCount",
  transactionsCount: "platform.columns.transactions",
  revenue: "platform.columns.revenue",
  createdAt: "general.columns.createdAt",
};

// Tabs of the platform settings page (UpdatePlatformView). Shared with global
// search so the current platform's tabs are searchable. Add further tabs here.
// The seven settings sections (general … domain) come first; the pre-existing
// documents / terminology / entity-account tabs stay at the end.
export const UPDATE_PLATFORM_PAGE_TAB_IDS = [
  "general",
  "entity-account",
  "regional",
  "appearance",
  "legal",
  "fees",
  "modules-integrations",
  "domain",
  "post-categories",
  "management",
  "documents",
  "terminology",
  "extras",
] as const;

export type UpdatePlatformPageTabId = (typeof UPDATE_PLATFORM_PAGE_TAB_IDS)[number];

export const UPDATE_PLATFORM_PAGE_TAB_LABELS: { [key in UpdatePlatformPageTabId]: MessageKey } = {
  general: "platform.pages.updatePlatform.tabs.general",
  regional: "platform.pages.updatePlatform.tabs.regional",
  appearance: "platform.pages.updatePlatform.tabs.appearance",
  legal: "platform.pages.updatePlatform.tabs.legal",
  fees: "platform.pages.updatePlatform.tabs.fees",
  "modules-integrations": "platform.pages.updatePlatform.tabs.modulesIntegrations",
  domain: "platform.pages.updatePlatform.tabs.domain",
  "post-categories": "platform.pages.updatePlatform.tabs.postCategories",
  management: "platform.pages.updatePlatform.tabs.management",
  extras: "platform.pages.updatePlatform.tabs.extras",
  documents: "documents.title",
  terminology: "terminology.settings.tab",
  "entity-account": "platform.tabs.entityAccount",
};
